
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Asynchronous Thunks ---

// Add Wp Api Setup Thunk
export const AddWpSetupMain = createAsyncThunk(
    'officialwa/AddWpSetupMain',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/wha_offcialwa_add`, values,);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to add Official WA"
            );
        }
    }
);

// --- Async Thunk: Fetch All Official WA Setup ---
export const fetchWpSetupAll = createAsyncThunk(
    'officialwa/fetchWpSetupAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/wha_offcialwa_view_All`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch Official WA setup'
            );
        }
    }
);

// Update Wp Setup Main Thunk
export const UpdateWpSetupMain = createAsyncThunk(
    'officialwa/UpdateWpSetupMain',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/wha_offcialwa_update/${id}`, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to update Official WA setup'
            );
        }
    }
);

// Delete Wp Setup Main Thunk
export const DeleteWpSetupMain = createAsyncThunk(
    'officialwa/deleteWpSetupMain',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/wha_offcialwa_delete/${id}`);
            return (id, response.data);
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to delete WhatsApp setup main'
            );
        }
    }
);

// Add Wp Setup Detail Thunk
export const AddWpSetupDetail = createAsyncThunk(
    'officialwa/AddWpSetupDetailById',
    async ({ selectedId, values }, { rejectWithValue }) => {
        try {
            const payload = {
                id: selectedId,
                WhatsappOffcialName: values.WhatsappOffcialName,
                Parameter: values.Parameter,
                ISURL: values.ISURL,
                IsMobile: values.IsMobile,
            };

            const response = await axios.post(`${BaseUrl}/wha_offcialwadt_add/${selectedId}`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// fetch Wp Detail Thunk
export const fetchWpSetupDetailAll = createAsyncThunk(
    'officialwa/fetchWpSetupDetailAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/wha_offcialwadt_view_All`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch WP Setup Details'
            );
        }
    }
);

// Update Wp Detail Thunk
export const UpdateWpSetupDetail = createAsyncThunk(
    'officialwa/updateWpSetupDetail',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/wha_offcialwadt_update/${id}`, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to update WP Setup Detail'
            );
        }
    }
);

// Delete Wp Detail Thunk
export const DeleteWpSetupDetail = createAsyncThunk(
    'officialwa/deleteWpSetupDetail',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/wha_offcialwadt_delete/${id}`);
            return (id, response.data);
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to delete WP Setup Detail'
            );
        }
    }
);

// --- Redux Slice ---
const WhatsappApiSetup = createSlice({
    name: 'wpapisetup',
    initialState: {

        // New State for Add Wp Api Setup
        AddWpSetupData: false,
        AddOfficialWALoading: false,
        AddOfficialWAError: null,

        // New State for GET all
        WpSetupData: [],
        WpSetupListLoading: false,
        WpSetupListError: null,

        // Add Wp Setup Detail
        AddWpSetupDetail: false,
        AddWpSetupDetailLoading: false,
        AddWpSetupDetailError: null,

        // GET all Wp Setup Detail Data
        WpSetupDetailData: [],
        WpSetupDetailLoading: false,
        WpSetupDetailError: null,

        UpdateWpSetupDetail: false,
        UpdateWpSetupDetailLoading: false,
        UpdateWpSetupDetailError: null,

        DeleteWpSetupDetailLoading: false,
        DeleteWpSetupDetailError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            // ---- Fetch Wp Api Setup handler ----
            .addCase(fetchWpSetupAll.pending, (state) => {
                state.WpSetupListLoading = true;
                state.WpSetupListError = null;
            })
            .addCase(fetchWpSetupAll.fulfilled, (state, action) => {
                state.WpSetupListLoading = false;
                state.WpSetupData = action.payload;
            })
            .addCase(fetchWpSetupAll.rejected, (state, action) => {
                state.WpSetupListLoading = false;
                state.WpSetupListError = action.payload;
            })

            // ---- Add Wp Api Setup handler ----
            .addCase(AddWpSetupMain.pending, (state) => {
                state.AddOfficialWALoading = true;
                state.AddOfficialWAError = null;
            })
            .addCase(AddWpSetupMain.fulfilled, (state, action) => {
                state.AddOfficialWALoading = false;
                state.AddWpSetupData = true;
            })
            .addCase(AddWpSetupMain.rejected, (state, action) => {
                state.AddOfficialWALoading = false;
                state.AddOfficialWAError = action.payload;
            })

            // ---- Update Wp Setup Main handler ----
            .addCase(UpdateWpSetupMain.pending, (state) => {
                state.UpdateWpSetupDetailLoading = true;
                state.UpdateWpSetupDetailError = null;
                state.UpdateWpSetupDetail = false;
            })
            .addCase(UpdateWpSetupMain.fulfilled, (state, action) => {
                state.UpdateWpSetupDetailLoading = false;
                state.UpdateWpSetupDetail = true;

                // Update item in state.WpSetupData manually
                const updated = action.payload?.data || {}; // depends on your response
                const index = state.WpSetupData.findIndex(item => item._id === updated._id);
                if (index !== -1) {
                    state.WpSetupData[index] = updated;
                }
            })

            .addCase(UpdateWpSetupMain.rejected, (state, action) => {
                state.UpdateWpSetupDetailLoading = false;
                state.UpdateWpSetupDetailError = action.payload;
                state.UpdateWpSetupDetail = false;
            })

            // ---- Delete Wp Setup Main handler ----
            .addCase(DeleteWpSetupMain.pending, (state) => {
                state.DeleteWpSetupDetailLoading = true;
                state.DeleteWpSetupDetailError = null;
            })
            .addCase(DeleteWpSetupMain.fulfilled, (state, action) => {
                state.DeleteWpSetupDetailLoading = false;
                state.WpSetupData = state.WpSetupData.filter(item => item._id !== action.payload);
            })
            .addCase(DeleteWpSetupMain.rejected, (state, action) => {
                state.DeleteWpSetupDetailLoading = false;
                state.DeleteWpSetupDetailError = action.payload;
            })

            // ---- Add Wp Setup Detail handler ----
            .addCase(AddWpSetupDetail.pending, (state) => {
                state.AddWpSetupDetailLoading = true;
                state.AddWpSetupDetailError = null;
                state.AddWpSetupDetail = false;
            })
            .addCase(AddWpSetupDetail.fulfilled, (state, action) => {
                state.AddWpSetupDetailLoading = false;
                state.AddWpSetupDetail = true;
            })
            .addCase(AddWpSetupDetail.rejected, (state, action) => {
                state.AddWpSetupDetailLoading = false;
                state.AddWpSetupDetailError = action.payload;
                state.AddWpSetupDetail = false;
            })

            // ---- Fetch Wp Setup Detail handler ----
            .addCase(fetchWpSetupDetailAll.pending, (state) => {
                state.WpSetupDetailLoading = true;
                state.WpSetupDetailError = null;
            })
            .addCase(fetchWpSetupDetailAll.fulfilled, (state, action) => {
                state.WpSetupDetailLoading = false;
                state.WpSetupDetailData = action.payload;
            })
            .addCase(fetchWpSetupDetailAll.rejected, (state, action) => {
                state.WpSetupDetailLoading = false;
                state.WpSetupDetailError = action.payload;
            })

            // ---- Update Wp Setup Detail handler ----
            .addCase(UpdateWpSetupDetail.pending, (state) => {
                state.UpdateWpSetupDetailLoading = true;
                state.UpdateWpSetupDetailError = null;
                state.UpdateWpSetupDetail = false;
            })
            .addCase(UpdateWpSetupDetail.fulfilled, (state, action) => {
                state.UpdateWpSetupDetailLoading = false;
                state.UpdateWpSetupDetail = true;
            })
            .addCase(UpdateWpSetupDetail.rejected, (state, action) => {
                state.UpdateWpSetupDetailLoading = false;
                state.UpdateWpSetupDetailError = action.payload;
                state.UpdateWpSetupDetail = false;
            })

            // ---- Delete Wp Setup Detail handler ----
            .addCase(DeleteWpSetupDetail.pending, (state) => {
                state.DeleteWpSetupDetailLoading = true;
                state.DeleteWpSetupDetailError = null;
            })
            .addCase(DeleteWpSetupDetail.fulfilled, (state, action) => {
                state.DeleteWpSetupDetailLoading = false;
                state.WpSetupDetailData = state.WpSetupDetailData.filter(
                    (item) => item._id !== action.payload
                );
            })
            .addCase(DeleteWpSetupDetail.rejected, (state, action) => {
                state.DeleteWpSetupDetailLoading = false;
                state.DeleteWpSetupDetailError = action.payload;
            })
    }
});

// Export the reducer
export default WhatsappApiSetup.reducer;